import React, { ChangeEvent, FC } from 'react';
import { useField } from 'formik';
import { TextField } from '@material-ui/core';
import { StandardTextFieldProps } from '@material-ui/core/TextField';

interface Props extends StandardTextFieldProps {
  enableTrim?: boolean;
  disableError?: boolean;
}

const ValidatedTextFieldNext: FC<Props> = props => {
  const { name, onChange, enableTrim, disableError, ...rest } = props;
  const [field, meta] = useField(name);

  const hasError = !!meta.error && !!meta.touched;
  const errorText =
    hasError && !disableError
      ? {
          helperText: meta.error,
        }
      : {};

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    if (enableTrim) {
      event.target.value = event.target.value.trim();
    }

    field.onChange(event);
    onChange?.(event);
  }

  return (
    <TextField
      error={!!meta.error && !!meta.touched}
      value={field.value || ''}
      inputProps={{ name: field.name, ...rest.inputProps }}
      onBlur={field.onBlur}
      onChange={handleChange}
      {...errorText}
      {...rest}
    />
  );
};

ValidatedTextFieldNext.defaultProps = {
  enableTrim: false,
};

export default ValidatedTextFieldNext;
